module.exports = __webpack_public_path__ + "static/media/homepage.68b3549b.jpg";